import { render, staticRenderFns } from "./GridVisitaRegistra.vue?vue&type=template&id=01f37330&"
import script from "./GridVisitaRegistra.vue?vue&type=script&lang=js&"
export * from "./GridVisitaRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports